// Attribution helpers — track investor source from URL
const STORAGE_KEY = "woodies_attribution";
const VISITOR_NAME_KEY = "woodies_visitor_name";

function humanize(slug) {
  if (!slug) return "";
  return slug
    .replace(/[-_]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ")
    .slice(0, 40);
}

export function captureAttributionFromUrl() {
  if (typeof window === "undefined") return;
  try {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const src = params.get("src");
    const utmSource = params.get("utm_source");
    const utmCampaign = params.get("utm_campaign");
    const utmMedium = params.get("utm_medium");

    const parts = [];
    if (src) parts.push(`src=${src}`);
    if (utmSource) parts.push(`utm_source=${utmSource}`);
    if (utmMedium) parts.push(`utm_medium=${utmMedium}`);
    if (utmCampaign) parts.push(`utm_campaign=${utmCampaign}`);

    if (parts.length > 0) {
      const referrer = document.referrer || "";
      const payload = {
        tag: parts.join(" · "),
        referrer,
        first_seen: new Date().toISOString(),
      };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }

    // Capture humanized visitor name for personalization
    const personSlug = src || params.get("for") || params.get("to");
    if (personSlug) {
      sessionStorage.setItem(VISITOR_NAME_KEY, humanize(personSlug));
    }
  } catch {
    /* noop */
  }
}

export function getAttribution() {
  if (typeof window === "undefined") return "";
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      const ref = parsed.referrer ? ` · ref:${new URL(parsed.referrer).hostname}` : "";
      return `${parsed.tag}${ref}`;
    }
    if (document.referrer) {
      try {
        const host = new URL(document.referrer).hostname;
        if (host && !host.includes(window.location.hostname)) {
          return `ref:${host}`;
        }
      } catch {
        /* noop */
      }
    }
    return "";
  } catch {
    return "";
  }
}

export function getVisitorName() {
  if (typeof window === "undefined") return "";
  try {
    return sessionStorage.getItem(VISITOR_NAME_KEY) || "";
  } catch {
    return "";
  }
}
